import { ReactComponent as LirariLandingPageDesktopLogo } from './../../assets/images/lirari-landing-page-desktop-logo.svg'
import { ReactComponent as LirariLandingPageMobileLogo } from './../../assets/images/lirari-landing-page-mobile-logo.svg'
import { ReactComponent as SeekersStory } from './../../assets/images/seekers-story.svg'
import { ReactComponent as MusiciansStory } from './../../assets/images/musicians-story.svg'
import { useNavigate } from 'react-router-dom'
import userClient from '../../Api/Lirari/Clients/userClient'
import { useAuth0 } from '@auth0/auth0-react'
import { UserTypes } from '../../Api/Lirari/Types/userTypes'

const ChoosePage = () => {
  const navigate = useNavigate()
  const { user, getAccessTokenSilently } = useAuth0()

  const createMusician = async () => {
    const lirariUser = await userClient.createUser(
      user!.sub!,
      user!.email!,
      UserTypes.Musician,
      await getAccessTokenSilently(),
    )
    navigate(`/u/${lirariUser.id}`)
  }

  const createSeeker = async () => {
    await userClient.createUser(user!.sub!, user!.email!, UserTypes.Musician, await getAccessTokenSilently())
    navigate(`/example-profile`)
  }

  return user?.sub == undefined || getAccessTokenSilently == undefined ? (
    <>Loading...</>
  ) : (
    <div className="bg-white flex flex-col lg:flex-row h-full min-w-full">
      <>
        {/* Desktop */}
        <div className="hidden lg:flex flex-col h-full w-1/3 pt-20 items-end z-10">
          <MusiciansStory className="min-h-[50rem] h-[50rem]" />
          <button
            className="flex mt-[-12rem] mx-[2.5rem] flex-col w-[256.01px] h-[92px] bg-[#DDFFDE] border border-black rounded-lg w-[209.86px] h-[55px] font-['Roboto_Serif'] font-semibold text-[30px] leading-[35px] flex items-center justify-center tracking-[0.1em] text-black justify-center items-center mt-[-17%]"
            onClick={async () => await createMusician()}
          >
            <div>Choose</div>
          </button>
        </div>
        <div className="hidden lg:flex flex-col w-1/3 items-center">
          <div className="text-6xl pt-10">Lirari</div>
          <div className="text-3xl pt-5">Choose Your</div>
          <div className="text-3xl">Path</div>
          <LirariLandingPageDesktopLogo className="min-h-[40rem] h-[42%]" />
        </div>
        <div className="hidden lg:flex flex-col h-full w-1/3 pt-20 items-start z-10">
          <SeekersStory className="min-h-[50rem] h-[50rem] pt-[1.5rem]"></SeekersStory>
          <button
            className="flex mt-[-12rem] mx-[2.7rem] flex-col w-[256.01px] h-[92px] bg-[#DDFFDE] border border-black rounded-lg w-[209.86px] h-[55px] font-['Roboto_Serif'] font-semibold text-[30px] leading-[35px] flex items-center justify-center tracking-[0.1em] text-black justify-center items-center mt-[-17%]"
            onClick={async () => await createSeeker()}
          >
            <div>Choose</div>
          </button>
        </div>
      </>
      <>
        {/* Mobile */}
        <div className="flex lg:hidden flex-row justify-center">
          <div className="flex flex-col text-center items-center">
            <div className="text-6xl pt-10">Lirari</div>
            <div className="text-3xl pt-5">The Professional</div>
            <div className="text-3xl">{`Musicians'`} Network</div>
          </div>
        </div>
        <div className="flex lg:hidden flex-col h-full w-full items-center pt-10">
          <MusiciansStory className="min-h-[50rem] h-[50rem]" />
          <button
            className="flex mt-[-12rem] mx-[2.5rem] flex-col w-[256.01px] h-[92px] bg-[#DDFFDE] border border-black rounded-lg w-[209.86px] h-[55px] font-['Roboto_Serif'] font-semibold text-[30px] leading-[35px] flex items-center justify-center tracking-[0.1em] text-black justify-center items-center mt-[-17%]"
            onClick={async () => await createMusician()}
          >
            <div>Choose</div>
          </button>
        </div>
        <div className="flex lg:hidden flex-row justify-center pt-20">
          <div className="flex flex-col text-center items-center">
            <LirariLandingPageMobileLogo />
          </div>
        </div>
        <div className="flex lg:hidden flex-col h-full w-full items-center pt-20">
          <SeekersStory className="min-h-[50rem] h-[50rem] pt-[1.5rem]" />
          <button
            className="flex mt-[-12rem] mx-[2.7rem] flex-col w-[256.01px] h-[92px] bg-[#DDFFDE] border border-black rounded-lg w-[209.86px] h-[55px] font-['Roboto_Serif'] font-semibold text-[30px] leading-[35px] flex items-center justify-center tracking-[0.1em] text-black justify-center items-center mt-[-17%]"
            onClick={async () => await createSeeker()}
          >
            <div>Choose</div>
          </button>
        </div>
      </>
    </div>
  )
}

export default ChoosePage
